import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';
import {
  fetchDoorsyRealestates,
  createDoorsyRealestate
} from '../Reducers/actions';

const DoorsyRealestates = ({
  realestates = [],
  loading = false,
  error = null,
  fetchDoorsyRealestates,
  createDoorsyRealestate
}) => {
  const [showCreateForm, setShowCreateForm] = useState(false);
  const [selectedRealestate, setSelectedRealestate] = useState(null);
  const [newRealestate, setNewRealestate] = useState({
    name: '',
    parent: '00000000-0000-0000-0000-000000000000'
  });

  useEffect(() => {
    loadRealestates();
  }, [fetchDoorsyRealestates]);

  // Select first realestate by default when data is loaded
  useEffect(() => {
    if (realestates && realestates.data && realestates.data.length > 0 && !selectedRealestate) {
      setSelectedRealestate(realestates.data[0]);
    }
  }, [realestates, selectedRealestate]);

  const loadRealestates = async () => {
    try {
      console.log('Loading realestates...');
      const result = await fetchDoorsyRealestates();
      console.log('Realestates result:', result);
    } catch (error) {
      console.error('Error loading realestates:', error);
    }
  };

  const handleCreateRealestate = async (e) => {
    e.preventDefault();

    if (!newRealestate.name.trim()) {
      alert('Naam is verplicht');
      return;
    }

    try {
      await createDoorsyRealestate(newRealestate);
      setNewRealestate({
        name: '',
        parent: '00000000-0000-0000-0000-000000000000'
      });
      setShowCreateForm(false);
      await loadRealestates(); // Refresh the list
      alert('Realestate succesvol aangemaakt!');
    } catch (error) {
      alert(`Fout bij aanmaken realestate: ${error.message}`);
    }
  };

  const resetForm = () => {
    setNewRealestate({
      name: '',
      parent: '00000000-0000-0000-0000-000000000000'
    });
    setShowCreateForm(false);
  };

  console.log('DoorsyRealestates render - realestates:', realestates, 'loading:', loading, 'error:', error);

  if (loading) {
    return (
      <div className="card">
        <div className="card-body text-center">
          <i className="fas fa-spinner fa-spin me-2"></i>
          Laden...
        </div>
      </div>
    );
  }

  return (
    <div className="card">
      <div className="card-header d-flex justify-content-between align-items-center">
        <h5 className="mb-0">
          <i className="fas fa-building me-2 text-primary"></i>
          Doorsy Realestates
        </h5>
        <button
          className="btn btn-primary btn-sm"
          onClick={() => setShowCreateForm(!showCreateForm)}
        >
          <i className="fas fa-plus me-1"></i>
          {showCreateForm ? 'Annuleren' : 'Nieuwe Realestate'}
        </button>
      </div>

      <div className="card-body">
        {error && (
          <div className="alert alert-danger">
            <i className="fas fa-exclamation-triangle me-2"></i>
            {error}
          </div>
        )}

        {/* Create Form */}
        {showCreateForm && (
          <div className="card mb-3">
            <div className="card-header">
              <h6 className="mb-0">Nieuwe Realestate Aanmaken</h6>
            </div>
            <div className="card-body">
              <form onSubmit={handleCreateRealestate}>
                <div className="row">
                  <div className="col-md-8">
                    <div className="mb-3">
                      <label className="form-label">
                        <i className="fas fa-building me-1"></i>
                        Naam *
                      </label>
                      <input
                        type="text"
                        className="form-control"
                        placeholder="Bijv. Camping De Vrolijke Vakantie"
                        value={newRealestate.name}
                        onChange={(e) => setNewRealestate({
                          ...newRealestate,
                          name: e.target.value
                        })}
                        required
                      />
                    </div>
                  </div>
                  <div className="col-md-4">
                    <div className="mb-3">
                      <label className="form-label">
                        <i className="fas fa-sitemap me-1"></i>
                        Parent UUID
                      </label>
                      <input
                        type="text"
                        className="form-control"
                        placeholder="00000000-0000-0000-0000-000000000000"
                        value={newRealestate.parent}
                        onChange={(e) => setNewRealestate({
                          ...newRealestate,
                          parent: e.target.value
                        })}
                      />
                    </div>
                  </div>
                </div>

                <div className="d-flex gap-2">
                  <button type="submit" className="btn btn-success">
                    <i className="fas fa-plus me-1"></i>
                    Aanmaken
                  </button>
                  <button
                    type="button"
                    className="btn btn-secondary"
                    onClick={resetForm}
                  >
                    <i className="fas fa-times me-1"></i>
                    Annuleren
                  </button>
                </div>
              </form>
            </div>
          </div>
        )}

        {/* Selected Realestate Info */}
        {selectedRealestate && (
          <div className="card mb-3 border-primary">
            <div className="card-header bg-primary text-white">
              <h6 className="mb-0">
                <i className="fas fa-check-circle me-2"></i>
                Geselecteerde Realestate
              </h6>
            </div>
            <div className="card-body">
              <div className="row">
                <div className="col-md-6">
                  <strong><i className="fas fa-building me-1"></i>Naam:</strong> {selectedRealestate.name}
                </div>
                <div className="col-md-6">
                  <strong><i className="fas fa-id-card me-1"></i>ID:</strong>
                  <code className="ms-1">{selectedRealestate.id}</code>
                </div>
              </div>
            </div>
          </div>
        )}

        {/* Realestates List */}
        <div className="d-flex justify-content-between align-items-center mb-3">
          <h6 className="mb-0">Realestates Lijst</h6>
          <button
            className="btn btn-outline-primary btn-sm"
            onClick={loadRealestates}
            disabled={loading}
          >
            <i className="fas fa-sync me-1"></i>
            Vernieuwen
          </button>
        </div>

        {realestates && realestates.data && realestates.data.length > 0 ? (
          <div className="table-responsive">
            <table className="table table-hover">
              <thead>
                <tr>
                  <th><i className="fas fa-id-card me-1"></i>ID</th>
                  <th><i className="fas fa-building me-1"></i>Naam</th>
                  <th><i className="fas fa-sitemap me-1"></i>Parent</th>
                  <th><i className="fas fa-calendar me-1"></i>Aangemaakt</th>
                </tr>
              </thead>
              <tbody>
                {realestates.data.map((realestate, index) => (
                  <tr
                    key={realestate.id || index}
                    className={`cursor-pointer ${selectedRealestate?.id === realestate.id ? 'table-primary' : ''}`}
                    onClick={() => setSelectedRealestate(realestate)}
                    style={{ cursor: 'pointer' }}
                  >
                    <td>
                      <div className="d-flex align-items-center">
                        {selectedRealestate?.id === realestate.id && (
                          <i className="fas fa-check-circle text-primary me-2"></i>
                        )}
                        <code className="text-muted small">
                          {realestate.id ? realestate.id.substring(0, 8) + '...' : 'N/A'}
                        </code>
                      </div>
                    </td>
                    <td>
                      <strong>{realestate.name || 'Geen naam'}</strong>
                    </td>
                    <td>
                      <code className="text-muted small">
                        {realestate.parent ? realestate.parent.substring(0, 8) + '...' : 'N/A'}
                      </code>
                    </td>
                    <td>
                      <small className="text-muted">
                        {realestate.created_at ?
                          new Date(realestate.created_at).toLocaleDateString('nl-NL') :
                          'Onbekend'
                        }
                      </small>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        ) : (
          <div className="text-center py-4">
            <i className="fas fa-building fa-3x text-muted mb-3"></i>
            <h6 className="text-muted">Geen realestates gevonden</h6>
            <p className="text-muted">
              {showCreateForm ?
                'Vul het formulier hierboven in om je eerste realestate aan te maken.' :
                'Klik op "Nieuwe Realestate" om je eerste realestate aan te maken.'
              }
            </p>
          </div>
        )}
      </div>
    </div>
  );
};

const mapStateToProps = (state) => ({
  realestates: state.toegangscontrole?.doorsy?.realestates || [],
  loading: state.toegangscontrole?.doorsy?.loading || false,
  error: state.toegangscontrole?.doorsy?.error || null
});

export default connect(mapStateToProps, {
  fetchDoorsyRealestates,
  createDoorsyRealestate
})(DoorsyRealestates);